import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { FormsModule } from '@angular/forms';
import { HeaderComponent } from './components/header/header.component';
import { MainLayoutComponent } from './components/main-layout/main-layout.component';
import { SidebarComponent } from './components/sidebar/sidebar.component';
import { SousHeaderComponent } from './components/sous-header/sous-header.component';
import { ArabicKeyboardComponent } from './components/arabic-keyboard/arabic-keyboard.component';
import { EntityInfoCardComponent } from './components/entity-info-card/entity-info-card.component';
import { DocumentViewerComponent } from './components/document-viewer/document-viewer.component';
import { DocumentsTabbedViewerComponent } from './components/documents-tabbed-viewer/documents-tabbed-viewer.component';
import { DocumentsViewPageComponent } from './pages/documents-view/documents-view-page.component';
import { UppercaseDirective } from './directives/uppercase.directive';
import { ArabicOnlyDirective } from './directives/arabic-only.directive';
import { PlayerStatsBarComponent } from './components/player-stats-bar/player-stats-bar.component';
import { RoleSelectorComponent } from './components/role-selector/role-selector.component';
import { NoFederationComponent } from './components/no-federation/no-federation.component';
import { InvalidFederationComponent } from './components/invalid-federation/invalid-federation.component';
import { FederationShellComponent } from './components/federation-shell/federation-shell.component';
import { DemandesListComponent } from './pages/Demandes/demandes-list/demandes-list.component';
import { DemandeSubmitComponent } from './pages/Demandes/demande-submit/demande-submit.component';
import { DemandeDetailComponent } from './pages/Demandes/demande-detail/demande-detail.component';
import { TransferDemandeComponent } from './pages/Demandes/transfer-demande/transfer-demande.component';
import { SeasonSelectorComponent } from './components/season-selector/season-selector.component';
import { ClubSelectComponent } from './components/club-select/club-select.component';
import { DemandeDocumentsSectionComponent } from './components/demande-documents-section/demande-documents-section.component';
import { NotificationBellComponent } from './components/notification-bell/notification-bell.component';

@NgModule({
  declarations: [
    HeaderComponent,
    MainLayoutComponent,
    SidebarComponent,
    SousHeaderComponent,
    ArabicKeyboardComponent,
    EntityInfoCardComponent,
    DocumentViewerComponent,
    DocumentsTabbedViewerComponent,
    DocumentsViewPageComponent,
    ArabicOnlyDirective,
    UppercaseDirective,
    PlayerStatsBarComponent,
    RoleSelectorComponent,
    NoFederationComponent,
    InvalidFederationComponent,
    FederationShellComponent,
    DemandesListComponent,
    DemandeSubmitComponent,
    DemandeDetailComponent,
    TransferDemandeComponent,
    SeasonSelectorComponent,
    ClubSelectComponent,
    DemandeDocumentsSectionComponent,
    NotificationBellComponent,
  ],
  imports: [
    CommonModule,
    RouterModule,
    FormsModule,
  ],
  exports: [
    CommonModule,
    RouterModule,
    FormsModule,
    HeaderComponent,
    MainLayoutComponent,
    SidebarComponent,
    SousHeaderComponent,
    ArabicKeyboardComponent,
    EntityInfoCardComponent,
    DocumentViewerComponent,
    DocumentsTabbedViewerComponent,
    DocumentsViewPageComponent,
    ArabicOnlyDirective,
    UppercaseDirective,
    PlayerStatsBarComponent,
    RoleSelectorComponent,
    NoFederationComponent,
    InvalidFederationComponent,
    FederationShellComponent,
    DemandesListComponent,
    DemandeSubmitComponent,
    DemandeDetailComponent,
    TransferDemandeComponent,
    SeasonSelectorComponent,
    ClubSelectComponent,
    DemandeDocumentsSectionComponent,
    NotificationBellComponent,
  ]
})
export class SharedModule { }
